module.exports = __webpack_public_path__ + "static/media/dashboard.25074d3d.svg";